import { Link } from 'react-router-dom';
import { comics } from '@/mocks/comics';

export default function HotRanking() {
  const hotList = [...comics]
    .sort((a, b) => a.hotRank - b.hotRank)
    .slice(0, 10);

  const formatViews = (v: number) => {
    if (v >= 10000) return `${(v / 10000).toFixed(1)}万`;
    return v.toString();
  };

  return (
    <section className="w-full px-4 md:px-6 py-10 md:py-14">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950">
              热门排行
            </h2>
            <p className="text-sm text-foreground-500 mt-1">
              当下最受欢迎的韩漫作品
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
          {hotList.map((comic, index) => (
            <Link
              key={comic.id}
              to={`/article/${comic.id}`}
              className="flex items-center gap-4 p-4 rounded-lg bg-background-50 border border-background-200/70 hover:border-primary-300 hover:shadow-sm transition-all duration-300 group no-underline"
            >
              <div className="flex-shrink-0 w-8 h-8 flex items-center justify-center">
                {index < 3 ? (
                  <span className={`w-7 h-7 flex items-center justify-center rounded-full text-xs font-bold text-background-50 ${
                    index === 0 ? 'bg-accent-500' : index === 1 ? 'bg-secondary-500' : 'bg-primary-500'
                  }`}>
                    {index + 1}
                  </span>
                ) : (
                  <span className="text-sm font-bold text-foreground-400">
                    {index + 1}
                  </span>
                )}
              </div>

              <div className="flex-shrink-0 w-14 h-20 rounded overflow-hidden">
                <img
                  src={comic.coverImage}
                  alt={comic.title}
                  className="w-full h-full object-cover object-top"
                />
              </div>

              <div className="flex-1 min-w-0">
                <h3 className="text-sm font-heading font-semibold text-foreground-950 group-hover:text-primary-600 transition-colors line-clamp-1 mb-1">
                  {comic.title}
                </h3>
                <p className="text-xs text-foreground-500 line-clamp-2 mb-2">
                  {comic.description}
                </p>
                <div className="flex items-center gap-3 text-xs text-foreground-400">
                  <span className="flex items-center gap-1">
                    <i className="ri-star-fill text-accent-500 text-xs"></i>
                    {comic.rating}
                  </span>
                  <span>{formatViews(comic.views)} 阅读</span>
                  <span>共{comic.chapters}话</span>
                </div>
              </div>

              <div className="flex-shrink-0">
                {comic.status === 'ongoing' ? (
                  <span className="px-2 py-1 text-xs bg-primary-100 text-primary-700 rounded-full font-medium whitespace-nowrap">
                    连载中
                  </span>
                ) : (
                  <span className="px-2 py-1 text-xs bg-secondary-100 text-secondary-700 rounded-full font-medium whitespace-nowrap">
                    已完结
                  </span>
                )}
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}